import { useMemo } from 'react';
import React from 'react';
import { LexicalDisplay } from '@components/Lexical/Display';
import { useLexicalValidate } from './useLexicalValidate';

export const usePostContent = ({
  lexicalContent,
  content,
}: {
  lexicalContent: unknown;
  content: string;
}) => {
  const validatedLexicalContent = useLexicalValidate(lexicalContent);

  const validatedContent = useMemo(() => {
    if (validatedLexicalContent) {
      return (
        <LexicalDisplay
          state={validatedLexicalContent}
          className="line-clamp-1 w-full text-base-l !text-base700"
        />
      );
    }
    return <div className="line-clamp-1 w-full text-base-l text-base700">{content}</div>;
  }, [content, validatedLexicalContent]);

  return { content: validatedContent };
};
